import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Compass",
        price: 50,
        disprice: 40,
        stock: 10,
        content: "Navigate your adventures with precision using our high-quality Compass. Designed for reliability and ease of use, this compass is an essential tool for hikers, campers, and trekkers.",
        description: "Our Compass provides accurate navigation, making it perfect for outdoor activities such as hiking and camping. Crafted with precision and durability, this tool is a must-have for every adventurer.",
        category: ["Outdoor Gear", "Navigation Tools"],
        tags: ["Compass", "Navigation", "Outdoor"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Stainless Steel" },
            { id: 2, title: "Dimensions", content: "2.5 x 3.5 inches" },
            { id: 3, title: "Weight", content: "0.3 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Daniel Davis",
                date: "May 5, 2024",
                rating: 5,
                content: "Absolutely love this compass! It's accurate and easy to use."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Emma Rodriguez",
                date: "May 6, 2024",
                rating: 5,
                content: "This compass exceeded my expectations. It's a must-have for any outdoor enthusiast!"
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Sleeping Bag",
        price: 50,
        disprice: 40,
        stock: 5,
        content: "Stay warm and comfortable during your camping trips with our high-quality Sleeping Bag. Designed for extreme weather conditions, this sleeping bag offers ultimate insulation and comfort for all-night rest.",
        description: "Our Sleeping Bag is perfect for outdoor adventures, providing warmth and comfort during cold nights. Crafted with premium materials, it ensures durability and coziness, making it an essential camping companion.",
        category: ["Camping Equipment", "Outdoor Gear"],
        tags: ["Sleeping", "Camping", "Outdoor"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Waterproof Polyester" },
            { id: 2, title: "Dimensions", content: "80 x 30 inches" },
            { id: 3, title: "Weight", content: "2.5 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "James Miller",
                date: "June 5, 2024",
                rating: 5,
                content: "Perfect sleeping bag for camping! Kept me warm even during the coldest nights."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Sophia Lee",
                date: "June 6, 2024",
                rating: 4.8,
                content: "Very comfortable and great insulation. A bit heavy, but overall a fantastic choice."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Hammock Tent",
        price: 80,
        disprice: 70,
        stock: 15,
        content: "Experience the ultimate outdoor relaxation with our Hammock Tent. This 2-in-1 design combines the comfort of a hammock with the protection of a tent, perfect for camping in various weather conditions.",
        description: "Our Hammock Tent provides a comfortable and secure sleeping space while offering a unique hammock experience. Lightweight and easy to set up, it’s the ideal choice for campers and adventurers who enjoy the great outdoors.",
        category: ["Camping Equipment", "Outdoor Gear"],
        tags: ["Hammock", "Camping", "Outdoor"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Ripstop Nylon" },
            { id: 2, title: "Dimensions", content: "8 x 4 feet" },
            { id: 3, title: "Weight", content: "5 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Michael Johnson",
                date: "April 10, 2024",
                rating: 5,
                content: "The Hammock Tent is a game-changer! It's super comfortable, easy to set up, and perfect for camping trips."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Olivia Brown",
                date: "April 11, 2024",
                rating: 4.7,
                content: "Great hammock tent, very durable and cozy. A bit tricky to assemble at first, but once set up, it’s fantastic!"
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Camping Cot",
        price: 60,
        disprice: 50,
        stock: 0,
        content: "Relax and sleep comfortably during your outdoor adventures with our sturdy Camping Cot. Designed for durability and comfort, this cot provides a raised sleeping surface, keeping you off the ground for a restful night’s sleep.",
        description: "Our Camping Cot is designed to support your body, offering superior comfort and stability during your camping trips. Lightweight, portable, and easy to set up, it's an essential piece of outdoor gear for any camper.",
        category: ["Camping Equipment", "Outdoor Gear"],
        tags: ["Camping", "Sleeping", "Outdoor"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "Aluminum Frame with Oxford Fabric" },
            { id: 2, title: "Dimensions", content: "75 x 28 x 17 inches" },
            { id: 3, title: "Weight", content: "7 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Jack Wilson",
                date: "April 15, 2024",
                rating: 5,
                content: "This cot is super comfortable and durable! It was perfect for my camping trip. Easy to set up and take down."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Ava Mitchell",
                date: "April 16, 2024",
                rating: 4.8,
                content: "Very comfortable and great for camping. The only downside is that it’s a bit heavy for backpacking, but perfect for car camping!"
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Hiking Boots",
        price: 120,
        disprice: 100,
        stock: 25,
        content: "Gear up for your outdoor expeditions with our premium Hiking Boots. Designed for durability and comfort, these boots provide excellent grip and support on various terrains, ensuring your feet stay comfortable throughout your hike.",
        description: "Our Hiking Boots are engineered for the toughest trails. Featuring waterproof material, breathable mesh, and advanced sole technology, they offer the perfect balance of protection and comfort. A must-have for any serious hiker or outdoor enthusiast.",
        category: ["Hiking Gear", "Outdoor Gear"],
        tags: ["Hiking", "Boots", "Outdoor"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "Waterproof Leather with Mesh Inserts" },
            { id: 2, title: "Sole", content: "Rubber with Deep Lugs for Traction" },
            { id: 3, title: "Weight", content: "1.5 lbs per boot" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "John Green",
                date: "March 10, 2024",
                rating: 5,
                content: "These boots are fantastic! Comfortable, waterproof, and great for long hikes. Highly recommend them!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Sophia Brown",
                date: "March 12, 2024",
                rating: 4.9,
                content: "Great boots! They handled rocky terrain perfectly, but they feel a bit stiff initially. Still, they are very durable."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Camping Stove",
        price: 60,
        disprice: 50,
        stock: 3,
        content: "Cook up delicious meals on the go with our compact and efficient Camping Stove. Perfect for outdoor adventures, this stove provides reliable cooking power with adjustable heat control and a lightweight design for easy portability.",
        description: "Our Camping Stove is designed for outdoor enthusiasts who need a portable cooking solution. Featuring wind-resistant burners, a stable base, and easy-to-use controls, this stove ensures you can cook anywhere, whether you're camping, hiking, or backpacking.",
        category: ["Camping Equipment", "Outdoor Gear"],
        tags: ["Camping", "Stove", "Outdoor"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4
        },
        addInfo: [
            { id: 1, title: "Fuel Type", content: "Butane/Propane" },
            { id: 2, title: "Dimensions", content: "9 x 7 x 4 inches" },
            { id: 3, title: "Weight", content: "1.2 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Lucas White",
                date: "April 1, 2024",
                rating: 5,
                content: "Excellent stove! It's compact, heats up quickly, and works great even in windy conditions."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Olivia Scott",
                date: "April 3, 2024",
                rating: 4.8,
                content: "Great for camping trips. Easy to set up and use. It could be a bit sturdier, but overall very satisfied."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Portable Grill",
        price: 80,
        disprice: 65,
        stock: 25,
        content: "Grill your favorite meals anywhere with our Portable Grill. Ideal for camping, tailgating, and outdoor cooking, this compact grill offers powerful heat and even cooking for a satisfying grilling experience.",
        description: "Our Portable Grill is perfect for outdoor enthusiasts who want to enjoy grilled food wherever they go. Featuring a foldable design for easy storage and transport, adjustable heat settings, and durable construction, it's the ultimate grill for all your outdoor adventures.",
        category: ["Camping Equipment", "Outdoor Gear"],
        tags: ["Grill", "Camping", "Outdoor"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4
        },
        addInfo: [
            { id: 1, title: "Fuel Type", content: "Charcoal" },
            { id: 2, title: "Dimensions", content: "15 x 11 x 6 inches" },
            { id: 3, title: "Weight", content: "4.5 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "James Miller",
                date: "March 20, 2024",
                rating: 5,
                content: "Fantastic portable grill! It's easy to set up and cooks evenly. Perfect for camping trips!"
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Sophia Lee",
                date: "March 25, 2024",
                rating: 4.7,
                content: "Great grill for outdoor activities. Lightweight and heats up quickly. Would recommend!"
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "GPS Device",
        price: 120,
        disprice: 100,
        stock: 0,
        content: "Stay on track during your outdoor adventures with our reliable GPS Device. Built for hikers, trekkers, and explorers, it offers accurate navigation and clear directions wherever you go.",
        description: "Our GPS Device ensures you never lose your way with precise location tracking. Designed for rugged conditions, it's water-resistant and features an easy-to-read screen, perfect for outdoor activities like hiking, trekking, and camping.",
        category: ["Navigation Tools", "Hiking Gear"],
        tags: ["GPS", "Navigation", "Outdoor"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4
        },
        addInfo: [
            { id: 1, title: "Display", content: "2.4-inch LCD Screen" },
            { id: 2, title: "Battery Life", content: "Up to 12 hours" },
            { id: 3, title: "Water Resistance", content: "IPX6 Waterproof" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Lucas Green",
                date: "April 1, 2024",
                rating: 5,
                content: "This GPS device is a game changer! It helped me navigate through tough trails with ease."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Olivia Brown",
                date: "April 3, 2024",
                rating: 4.8,
                content: "Very accurate and reliable. A must-have for any serious hiker or adventurer."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "First Aid Kit",
        price: 35,
        disprice: 30,
        stock: 50,
        content: "Be prepared for any situation with our comprehensive First Aid Kit. Packed with essential medical supplies, it’s perfect for camping, hiking, and emergency preparedness.",
        description: "Our First Aid Kit contains all the basic supplies you need to treat injuries in the outdoors. From bandages to antiseptic wipes, this kit ensures you’re ready for minor emergencies on your adventures.",
        category: ["camping equipment", "Travel Essentials"],
        tags: ["FirstAid", "Camping", "Survival"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4
        },
        addInfo: [
            { id: 1, title: "Contents", content: "Bandages, Antiseptic Wipes, Gauze Pads, Tweezers, Scissors, Adhesive Tape, Instant Cold Pack, and more." },
            { id: 2, title: "Dimensions", content: "8 x 6 x 2 inches" },
            { id: 3, title: "Weight", content: "1.2 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "James Clark",
                date: "March 20, 2024",
                rating: 5,
                content: "Great kit with everything you need for outdoor emergencies. I take it everywhere!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Sarah Smith",
                date: "March 25, 2024",
                rating: 4.9,
                content: "Compact, well-organized, and very useful. A must-have for any outdoor trip."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Navigation Device",
        price: 150,
        disprice: 130,
        stock: 20,
        content: "Stay on track during your outdoor adventures with our advanced Navigation Device. Featuring a high-resolution screen, GPS tracking, and offline maps, it’s built for explorers who demand precision and reliability.",
        description: "Our Navigation Device offers real-time GPS tracking, precise navigation, and offline map capabilities, ensuring you never lose your way. Whether you’re hiking, camping, or on a road trip, this device is your ultimate guide.",
        category: ["Navigation Tools", "Travel Essentials"],
        tags: ["GPS", "Navigation", "Travel"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4
        },
        addInfo: [
            { id: 1, title: "Battery Life", content: "Up to 12 hours of continuous use" },
            { id: 2, title: "Screen Size", content: "5-inch high-resolution display" },
            { id: 3, title: "Water Resistance", content: "IP67 Rated" },
            { id: 4, title: "Connectivity", content: "Wi-Fi, Bluetooth, and Offline Maps" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "David Thompson",
                date: "April 10, 2024",
                rating: 5,
                content: "Incredible device! Super accurate, easy to use, and the battery lasts all day. Perfect for long hikes."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Olivia Johnson",
                date: "April 12, 2024",
                rating: 4.8,
                content: "Love it! The offline maps are a game changer when you're in the wilderness. A bit bulky, but totally worth it."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Travel Blanket",
        price: 40,
        disprice: 35,
        stock: 25,
        content: "Stay warm and cozy wherever you go with our lightweight, compact Travel Blanket. Perfect for camping, hiking, or just relaxing during long trips, it’s an essential accessory for every traveler.",
        description: "Our Travel Blanket is made from soft, breathable fabric that provides warmth without the bulk. Designed to fit easily into your bag, it's ideal for outdoor adventures, flights, and road trips.",
        category: ["Travel Essentials", "Camping Equipment"],
        tags: ["Sleeping", "Travel", "Outdoor"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "Microfiber Fleece" },
            { id: 2, title: "Dimensions", content: "50 x 70 inches" },
            { id: 3, title: "Weight", content: "1 lb" },
            { id: 4, title: "Machine Washable", content: "Yes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Liam Foster",
                date: "March 20, 2024",
                rating: 5,
                content: "Perfect for travel! It's lightweight and packs small, but keeps me warm during my flights and camping trips."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Isabella Clark",
                date: "March 22, 2024",
                rating: 4.7,
                content: "Love the softness of this blanket. Ideal for outdoor trips, though it could be a bit bigger for added comfort."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Suspension Shelter",
        price: 150,
        disprice: 130,
        stock: 18,
        content: "Experience ultimate comfort and protection in the wild with our Suspension Shelter. Perfect for hanging camping setups, it offers a secure, waterproof shelter high above the ground.",
        description: "Designed for the modern adventurer, our Suspension Shelter is lightweight, durable, and easy to set up. It offers all-around weather protection and is an ideal choice for those who enjoy camping in unconventional places.",
        category: ["Camping Equipment", "Outdoor Gear"],
        tags: ["Hammock", "Camping", "Outdoor"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Density Nylon" },
            { id: 2, title: "Dimensions", content: "8 x 8 feet" },
            { id: 3, title: "Weight", content: "4.5 lbs" },
            { id: 4, title: "Waterproof", content: "Yes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Jack Thompson",
                date: "April 3, 2024",
                rating: 5,
                content: "Amazing shelter! Easy to set up, and it keeps me dry during rainy nights. Perfect for hanging camping trips."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Ava Mitchell",
                date: "April 5, 2024",
                rating: 4.8,
                content: "Love the design of this shelter. It's a bit heavy, but it's worth it for the comfort and weather protection it provides."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Foldable Bed",
        price: 120,
        disprice: 100,
        stock: 25,
        content: "Sleep comfortably wherever you go with our Foldable Bed. Lightweight and compact, it’s perfect for camping, travel, or as an extra bed for guests.",
        description: "Our Foldable Bed is designed for convenience and comfort. Made with high-quality materials, it easily folds up for storage, offering a space-saving solution without compromising comfort.",
        category: ["Camping Equipment", "Travel Essentials"],
        tags: ["Camping", "Sleeping", "Outdoor"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "Steel Frame & Fabric" },
            { id: 2, title: "Dimensions", content: "75 x 30 x 15 inches" },
            { id: 3, title: "Weight", content: "8.5 lbs" },
            { id: 4, title: "Foldable", content: "Yes, Compact for Easy Storage" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "William Foster",
                date: "March 10, 2024",
                rating: 5,
                content: "Incredible comfort! I used it on a camping trip, and it was perfect. Easy to set up and fold away."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Sophia Turner",
                date: "March 15, 2024",
                rating: 4.5,
                content: "Great product for travel and camping. It's a bit heavy for hiking, but it's very comfortable and sturdy."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Trekking Footwear",
        price: 80,
        disprice: 65,
        stock: 0,
        content: "Conquer rugged trails with ease using our Trekking Footwear. Built for durability, comfort, and support, these shoes are designed to handle the toughest terrains.",
        description: "Our Trekking Footwear provides excellent grip, shock absorption, and breathability, ensuring a comfortable and secure fit on all your outdoor adventures. Whether you're trekking up mountains or exploring forests, these shoes will support your every step.",
        category: ["Hiking Gear", "Outdoor Gear"],
        tags: ["Hiking", "Boots", "Outdoor"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4
        },
        addInfo: [
            { id: 1, title: "Material", content: "Waterproof Fabric & Rubber Sole" },
            { id: 2, title: "Shoe Type", content: "Mid-Top" },
            { id: 3, title: "Weight", content: "1.2 lbs (per shoe)" },
            { id: 4, title: "Size Range", content: "7-12 US" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Liam Brooks",
                date: "March 22, 2024",
                rating: 5,
                content: "These shoes are perfect for trekking! They provide amazing support and comfort during long hikes."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Emily Clark",
                date: "March 25, 2024",
                rating: 4.8,
                content: "I love these trekking shoes! They’re sturdy, comfortable, and the waterproof feature is great for rainy days."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Portable Burner",
        price: 45,
        disprice: 35,
        stock: 25,
        content: "Cook meals anywhere with our Portable Burner. Perfect for camping, hiking, and outdoor adventures, this compact and lightweight burner offers reliable cooking performance.",
        description: "Our Portable Burner is designed for convenience and portability, making it easy to cook your favorite meals on the go. Whether you’re camping in the wilderness or cooking in the backyard, this burner is the ideal solution for outdoor cooking.",
        category: ["Camping Equipment", "Outdoor Gear"],
        tags: ["Camping", "Stove", "Outdoor"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4
        },
        addInfo: [
            { id: 1, title: "Fuel Type", content: "Butane/Propane" },
            { id: 2, title: "Dimensions", content: "8 x 8 x 3 inches" },
            { id: 3, title: "Weight", content: "1.5 lbs" },
            { id: 4, title: "Burning Power", content: "10,000 BTU" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Ryan Walker",
                date: "April 1, 2024",
                rating: 5,
                content: "This portable burner is a game-changer! It’s perfect for camping trips and heats up food quickly."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Sophia Lee",
                date: "April 3, 2024",
                rating: 4.5,
                content: "Great burner for outdoor use. It’s compact and lightweight, but I wish the fuel lasted a bit longer."
            }
        ]
    }
];

export default products;